<template>
  <div v-if="status === true">
    <!-- <Carousel/> -->
    <HomeProducts v-if="StatusHomeNewProduct" :propsData='newArrivals' header='สินค้ามาใหม่' :check='status'/>
    <HomeProducts v-if="StatusHomeBestProduct" :propsData='bestSeller' header='สินค้าขายดี' :check='status'/>
    <HomeProducts v-if="StatusHomeRecoment" :propsData='recommend' header='สินค้าแนะนำ' :check='status'/>
    <ThaiDotCom />
    <!-- <HomeCategoryProduct :propsDataCat='GetAllProduct.CategoryList' header='หมวดหมู่สินค้ายอดนิยม'/> -->
    <!-- <NewArrivals :propsData='bestSeller'/> -->
  </div>
</template>

<script>
import { Decode } from '@/services'
const newArrivals = []
// for (let i = 0; i < 50; i++) {
//   newArrivals.push({
//     product_id: i,
//     name: `Data Title newArrivals ${i}`,
//     price: ` ${i * 10}`,
//     stock: `${i}`,
//     image: `https://picsum.photos/500/300?image=${i * 5 + 10}`
//   })
// }
const bestSeller = []
// for (let i = 0; i < 50; i++) {
//   bestSeller.push({
//     product_id: i,
//     name: `Data Title bestSeller ${i}`,
//     price: ` ${i * 10}`,
//     stock: `${i}`,
//     image: `https://picsum.photos/500/300?image=${i * 5 + 10}`
//   })
// }
const recommend = []
for (let i = 0; i < 50; i++) {
  recommend.push({
    product_id: i,
    name: `Data Title recommend ${i}`,
    price: ` ${i * 10}`,
    stock: `${i}`,
    image: `https://picsum.photos/500/300?image=${i * 5 + 10}`
  })
}
const ProductList = []
for (let i = 0; i < 20; i++) {
  ProductList.push(
    {
      product_id: i,
      name: `Data Title recommend ${i}`,
      price: ` ${i * 10}`,
      stock: `${i}`,
      image: `https://picsum.photos/500/300?image=${i * 5 + 10}`
    }
  )
}
const Category = []
Category.push(
  {
    category_list: [{
      category_name: 'อุปกรณ์โรงงาน',
      category_img: 'https://images.unsplash.com/photo-1429514513361-8fa32282fd5f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3264&q=80'
    }],
    product_list: ProductList
  },
  {
    category_list: [{
      category_name: 'อุปกรณ์สำนักงาน',
      category_img: 'https://images.unsplash.com/photo-1498038432885-c6f3f1b912ee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2100&q=80'
    }],
    product_list: ProductList
  },
  {
    category_list: [{
      category_name: 'เฟอร์นิเจอร์',
      category_img: 'https://images.unsplash.com/photo-1542320868-f4d80389e1c4?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=3750&q=80'
    }],
    product_list: ProductList
  }
)
const CategoryList = []
CategoryList.push({ data: Category })
export default {
  components: {
    // Carousel: () => import('@/components/Carousel/CarouselHome'),
    HomeProducts: () => import(/* webpackChunkName: "HomeProduct-chunk" */ '@/components/Home/HomeProductUI'),
    ThaiDotCom: () => import(/* webpackChunkName: "thiaDotCom-chunk" */ '@/components/Carousel/ThaiDotCom')
    // HomeCategoryProduct: () => import('@/components/Home/HomeCategoryProduct')
    // NewArrivals: () => import('@/components/Home/HomeProduct/NewArrivals')
  },
  data () {
    return {
      GetAllProduct: {
        newArrivals,
        bestSeller,
        recommend,
        CategoryList
      },
      newArrivals: [],
      bestSeller: [],
      recommend: [],
      status: true,
      StatusHomeNewProduct: false,
      StatusHomeBestProduct: false,
      StatusHomeRecoment: false,
      tokenstatus: '',
      dataRole: ''
    }
  },
  async created () {
    this.oneData = []
    if (localStorage.getItem('oneData') !== null) {
      this.oneData = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
    }
    window.scrollTo(0, 0)
    this.$EventBus.$emit('CheckFooter')
    this.$EventBus.$emit('getPath')
    this.$EventBus.$on('getHomepageItems', this.getNewProduct)
    // await this.getHomepageItems()
    await this.getNewProduct()
    this.checkRemoveDataGracz()
  },
  // mounted () {
  //   this.$EventBus.$on('getHomepageItemst', this.getNewProduct)
  // },
  methods: {
    async getNewProduct () {
      this.$store.commit('openLoader')
      var companyID = ''
      if (localStorage.getItem('roleUser') !== null) {
        this.dataRole = JSON.parse(localStorage.getItem('roleUser'))
        if (localStorage.getItem('oneData') !== null) {
          this.tokenstatus = this.oneData.user.access_token
        } else {
          this.tokenstatus = ''
        }
      } else {
        this.dataRole = ''
        this.tokenstatus = ''
      }
      if (localStorage.getItem('SetRowCompany') !== null) {
        var companyDataSet = JSON.parse(Decode.decode(localStorage.getItem('SetRowCompany')))
        companyID = companyDataSet.company.company_id
      } else {
        companyID = '-1'
      }
      var data
      data = {
        role_user: this.dataRole !== '' ? this.dataRole.role : 'ext_buyer',
        company_id: companyID
      }
      // data = {
      //   token: this.tokenstatus,
      //   role_user: this.dataRole !== '' ? this.dataRole.role : 'ext_buyer',
      //   begin_search_type: 'component',
      //   begin_search_details: {
      //     custom_user_ID: '1',
      //     what_component: 'new_product',
      //     component_id: ''
      //   },
      //   user_detail: {
      //     company_id: companyID
      //   }
      // }
      await this.$store.dispatch('actionsProductNew', data)
      var response = await this.$store.state.ModuleProductNode.stateProductNew
      if (response.ok === 'y') {
        this.newArrivals = []
        if (response.query_result.length !== 0) {
          this.newArrivals = await [...response.query_result]
          this.status = true
          this.StatusHomeNewProduct = true
        } else {
          this.newArrivals = 'ยังไม่มีรายการสินค้ามาใหม่'
          this.status = true
          this.StatusHomeNewProduct = false
        }
        await this.getBestSeller()
      } else {
        this.newArrivals = []
        this.status = true
        this.StatusHomeNewProduct = false
        await this.getBestSeller()
      }
    },
    async getBestSeller () {
      // alert('เข้า')
      var companyID = ''
      if (localStorage.getItem('roleUser') !== null) {
        this.dataRole = JSON.parse(localStorage.getItem('roleUser'))
        if (localStorage.getItem('oneData') !== null) {
          this.tokenstatus = this.oneData.user.access_token
        } else {
          this.tokenstatus = ''
        }
      } else {
        this.dataRole = ''
        this.tokenstatus = ''
      }
      if (localStorage.getItem('SetRowCompany') !== null) {
        var companyDataSet = JSON.parse(Decode.decode(localStorage.getItem('SetRowCompany')))
        companyID = companyDataSet.company.company_id
      } else {
        companyID = '-1'
      }
      var data2
      // data2 = {
      //   token: this.tokenstatus,
      //   role_user: this.dataRole !== '' ? this.dataRole.role : 'ext_buyer',
      //   begin_search_type: 'component',
      //   begin_search_details: {
      //     custom_user_ID: '1',
      //     what_component: 'best_seller',
      //     component_id: ''
      //   },
      //   user_detail: {
      //     company_id: companyID
      //   }
      // }
      data2 = {
        role_user: this.dataRole !== '' ? this.dataRole.role : 'ext_buyer',
        company_id: companyID
      }
      await this.$store.dispatch('actionsProductBestSellerHome', data2)
      var response2 = await this.$store.state.ModuleProductNode.stateProductBestSeller
      console.log('data', response2)
      if (response2.ok === 'y') {
        this.bestSeller = []
        if (response2.query_result.length !== 0) {
          this.bestSeller = await [...response2.query_result]
          this.status = true
          this.StatusHomeBestProduct = true
        } else {
          this.bestSeller = 'ยังไม่มีรายการสินค้าขายดี'
          this.status = true
          this.StatusHomeBestProduct = false
        }
        await this.getRecommentProduct()
      } else {
        this.bestSeller = []
        this.status = true
        this.StatusHomeBestProduct = false
        await this.getRecommentProduct()
      }
    },
    async getRecommentProduct () {
      var companyID = ''
      if (localStorage.getItem('roleUser') !== null) {
        this.dataRole = JSON.parse(localStorage.getItem('roleUser'))
        if (localStorage.getItem('oneData') !== null) {
          this.tokenstatus = this.oneData.user.access_token
        } else {
          this.tokenstatus = ''
        }
      } else {
        this.dataRole = ''
        this.tokenstatus = ''
      }
      if (localStorage.getItem('SetRowCompany') !== null) {
        var companyDataSet = JSON.parse(Decode.decode(localStorage.getItem('SetRowCompany')))
        companyID = companyDataSet.company.company_id
      } else {
        companyID = '-1'
      }
      var data3
      // data3 = {
      //   token: this.tokenstatus,
      //   role_user: this.dataRole !== '' ? this.dataRole.role : 'ext_buyer',
      //   begin_search_type: 'component',
      //   begin_search_details: {
      //     custom_user_ID: '1',
      //     what_component: 'recommended_product',
      //     component_id: ''
      //   },
      //   user_detail: {
      //     company_id: companyID
      //   }
      // }
      data3 = {
        role_user: this.dataRole !== '' ? this.dataRole.role : 'ext_buyer',
        company_id: companyID
      }
      await this.$store.dispatch('actionsProductRecomment', data3)
      var response3 = await this.$store.state.ModuleProductNode.stateProductRecomment
      if (response3.ok === 'y') {
        this.recommend = []
        if (response3.query_result.length !== 0) {
          this.recommend = await [...response3.query_result]
          this.status = true
          this.StatusHomeRecoment = true
        } else {
          this.recommend = 'ยังไม่มีรายการสินค้าแนะนำ'
          this.status = true
          this.StatusHomeRecoment = false
        }
        this.$store.commit('closeLoader')
      } else {
        this.recommend = []
        this.status = true
        this.StatusHomeRecoment = false
        this.$store.commit('closeLoader')
      }
    },
    async checkRemoveDataGracz () {
      // console.log('12345')
      // เวลาใช้งานใน Gracz menu ทุกครั้งที่กดออกเว็บไป แล้วกลับเข้ามาใหม่จะให้ทำการ clear localStorage แล้ว emit OnlinePurchase เพื่อทำการสลับ menu ขวามือเป็นของ panit
      if (this.$router.currentRoute.name === 'HomeProduct') {
        await localStorage.removeItem('OnlinePurchase')
        await localStorage.removeItem('CheckSalesOrAdminGracz')
        await localStorage.removeItem('UserDetailSelling')
        await localStorage.removeItem('categoryType')
        await localStorage.removeItem('GraczSelectCustomer')
        await localStorage.removeItem('GraczProductPromotionSelected')
        await localStorage.removeItem('GraczPromotionSelected')
        this.$EventBus.$emit('OnlinePurchase')
        this.$EventBus.$emit('changeAppBarPanit')
      }
    }
    // async getHomepageItems () {
    //   this.$store.commit('openLoader')
    //   var companyID = ''
    //   if (localStorage.getItem('roleUser') !== null) {
    //     this.dataRole = JSON.parse(localStorage.getItem('roleUser'))
    //     if (localStorage.getItem('oneData') !== null) {
    //       this.tokenstatus = this.oneData.user.access_token
    //     } else {
    //       this.tokenstatus = ''
    //     }
    //   } else {
    //     this.dataRole = ''
    //     this.tokenstatus = ''
    //   }
    //   if (localStorage.getItem('SetRowCompany') !== null) {
    //     var companyDataSet = JSON.parse(Decode.decode(localStorage.getItem('SetRowCompany')))
    //     companyID = companyDataSet.company.company_id
    //   } else {
    //     companyID = '-1'
    //   }
    //   var data = ''
    //   var data2 = ''
    //   var data3 = ''
    //   data = {
    //     token: this.tokenstatus,
    //     role_user: this.dataRole !== '' ? this.dataRole.role : 'ext_buyer',
    //     begin_search_type: 'component',
    //     begin_search_details: {
    //       custom_user_ID: '1',
    //       what_component: 'new_product',
    //       component_id: ''
    //     },
    //     user_detail: {
    //       company_id: companyID
    //     }
    //   }
    //   data2 = {
    //     token: this.tokenstatus,
    //     role_user: this.dataRole !== '' ? this.dataRole.role : 'ext_buyer',
    //     begin_search_type: 'component',
    //     begin_search_details: {
    //       custom_user_ID: '1',
    //       what_component: 'best_seller',
    //       component_id: ''
    //     },
    //     user_detail: {
    //       company_id: companyID
    //     }
    //   }
    //   data3 = {
    //     token: this.tokenstatus,
    //     role_user: this.dataRole !== '' ? this.dataRole.role : 'ext_buyer',
    //     begin_search_type: 'component',
    //     begin_search_details: {
    //       custom_user_ID: '1',
    //       what_component: 'recommended_product',
    //       component_id: ''
    //     },
    //     user_detail: {
    //       company_id: companyID
    //     }
    //   }
    //   await this.$store.dispatch('actionsProduct', data)
    //   var response = await this.$store.state.ModuleProductNode.stateProducts
    //   await this.$store.dispatch('actionsProduct', data2)
    //   var response2 = await this.$store.state.ModuleProductNode.stateProducts
    //   await this.$store.dispatch('actionsProduct', data3)
    //   var response3 = await this.$store.state.ModuleProductNode.stateProducts
    //   this.newArrivals = []
    //   bestSeller = []
    //   this.recommend = []
    //   if (response.ok === 'y') {
    //     if (response.query_result.length !== 0 || response2.query_result.length !== 0 || response3.query_result.length !== 0) {
    //       if (response.query_result.length !== 0) {
    //         this.newArrivals = response.query_result
    //         this.status = true
    //         this.StatusHomeNewProduct = true
    //       } else {
    //         this.newArrivals = 'ยังไม่มีรายการสินค้ามาใหม่'
    //         this.status = true
    //         this.StatusHomeNewProduct = false
    //       }
    //       if (response2.query_result.length !== 0) {
    //         bestSeller = response2.query_result
    //         this.status = true
    //         this.StatusHomeBestProduct = true
    //       } else {
    //         bestSeller = 'ยังไม่มีรายการสินค้าขายดี'
    //         this.status = true
    //         this.StatusHomeBestProduct = false
    //       }
    //       if (response3.query_result.length !== 0) {
    //         this.recommend = response3.query_result
    //         this.status = true
    //         this.StatusHomeRecoment = true
    //       } else {
    //         this.recommend = 'ยังไม่มีรายการสินค้าแนะนำ'
    //         this.status = true
    //         this.StatusHomeRecoment = false
    //       }
    //       this.$store.commit('closeLoader')
    //     } else {
    //       this.newArrivals = []
    //       bestSeller = []
    //       this.recommend = []
    //       this.status = true
    //       this.StatusHomeNewProduct = false
    //       this.StatusHomeBestProduct = false
    //       this.StatusHomeRecoment = false
    //       this.$store.commit('closeLoader')
    //     }
    //   } else {
    //     this.$store.commit('closeLoader')
    //     const Toast = this.$swal.mixin({
    //       toast: true,
    //       showConfirmButton: false,
    //       timer: 1500,
    //       timerProgressBar: true
    //     })
    //     Toast.fire({
    //       icon: 'error',
    //       title: 'ไม่มีสินค้าในหน้าเพจ',
    //       text: 'โปรดติดต่อแอดมิน'
    //     })
    //   }
    // }
  }
}
</script>
